<!-- kurangin kondisi nullish di HTML, taro di usecase jadi disini as is -->

<div class="progress-container">
  <progress [value]="purchasePercentage()" max="100"></progress>
  <div class="progress-text">{{purchasePercentage() | percentage}} {{'promo.sold' | translate}}</div>
</div>
